export type Branding = {
  clientBrand?: string
  logoSrc: string
  logoAlt: string
}

const defaultBranding: Branding = {
  clientBrand: '#5c3cd8',
  logoSrc: '/logo192withSaveSpace.png',
  logoAlt: 'EIDU Logo',
}

const kenyaMoeBranding: Branding = {
  clientBrand: '#00aeee',
  logoSrc: '/kenya-moe-logo.png',
  logoAlt: 'Kenya MOE Logo',
}

const landscapingProjectOrgId = '89049ab4-0e99-4008-bebd-58e5634b2067'

export const getBranding = (organizationId: string | undefined): Branding =>
  organizationId === landscapingProjectOrgId ? kenyaMoeBranding : defaultBranding
